module.exports = __webpack_public_path__ + "img/company_process.bd5c1932.png";